import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-strasse',
    templateUrl: './input-field.component.html'
} )
export class StreetComponent extends AbstractFieldComponent<string>  {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.street' );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.street = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.street;
    }
}
